import { createSlice } from '@reduxjs/toolkit';

// 시스템 바 높이 상태 관리(전역 상태 초기값)
/**
 * 시스템 바 높이 상태 관리
 * - statusBar: 상단 시스템UI 높이
 * - navBar: 하단 시스템UI 높이
 */

const initialState = {
  statusBar: 0, // 상단 시스템UI 높이
  navBar: 0, // 하단 시스템UI 높이
};

const SystemBarSlice = createSlice({
  name: 'SystemBar',
  initialState,
  reducers: {
    setSystemBarInsets: (state, action) => {
      state.statusBar = action.payload.statusBarHeight;
      state.navBar = action.payload.navBarHeight;
    },
  },
});

export const SystemBarActions = SystemBarSlice.actions;
export default SystemBarSlice.reducer;
